import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {BookingAreaTypeModel} from '../model/masters/bookingAreaType.model'
import {ZoneModel} from '../model/masters/zone.model';
import {LocalityModel} from '../model/masters/locality.model';
import {PurposeModel } from '../model/masters/purpose.model'
import { StateModel } from '../model/masters/state.model';
import { CountryModel } from '../model/masters/country.model';
import { DistrictModel } from '../model/masters/distict.model';
import { AreaDescriptionModel } from '../model/masters/areaDescription.model';
import { LandDescriptionModel } from '../model/masters/landDescription.model';
import { FunctionTypeModel } from '../model/masters/functionType.model';
import { ResponeBookingDetails } from '../model/FormsEntity/ResponeMessage';
import { CategoryTypeModel } from '../model/masters/categoryType.model';
import { FileNumberModel } from '../model/masters/fileNumber.model';
import { OnlineBooking } from '../model/FormsEntity/onlineBooking';
import { ResponseMessage } from '../model/FormsEntity/response';
import { environment } from '../../environments/environment';
import { RecordDamageOnSiteCommunityHallModel } from '../model/FormsEntity/RecordDamageOnSiteCommunityHallModel';
//const userUrl=window.location.protocol+'//localhost:8081//dda//masterData//';

  @Injectable({providedIn: 'root'})
  
  export class BookingManagementService {
    private usersUrl: string;
    private communityHall: string;
    private workFlow:string;
    private returnWorkFlow:string;
    private moneyDeductionWF : string;private cancelCHWF : string;
    private relaxationWF : string;
    constructor(private http:HttpClient) {
        this.communityHall = 'http://localhost:8081/dda/communityHall/';
        this.workFlow = 'http://localhost:8081/communityHall/workflow/';
        this.returnWorkFlow = 'http://localhost:8081/returnCommunityHall/workflow/';
        this.moneyDeductionWF = 'http://localhost:8081/moneyDeduction/workflow/';
        this.cancelCHWF = 'http://localhost:8081/communityHallCancellation/workflow/';
         this.usersUrl = 'http://localhost:8081/dda/masterData/';
         this.relaxationWF = 'http://localhost:8081/communityHallRelaxation/workflow/';
         //this.communityHall = 'http://10.8.16.38:9080/dda/communityHall/';
        this.communityHall = environment.baseUrl + 'communityHall/';
        this.workFlow = environment.wflowUrl +  'communityHall/workflow/';
      //  this.returnWorkFlow = environment.baseUrl + 'returnCommunityHall/workflow/';
      //  this.relaxationWF = environment.baseUrl + 'communityHallRelaxation/workflow/';
    }

    public getBookingType(){
      return this.http.get<BookingAreaTypeModel>(this.usersUrl +'getBookingAreaType');
    }
    public getZone(){
        return this.http.get<ZoneModel>(this.usersUrl +'getZoneList');
    }
    public getLocality(zonePk,typeOfBooking){
      console.log(zonePk , typeOfBooking);
      return this.http.get<any>(this.usersUrl + 'getLocalityList/'+zonePk+'/'+typeOfBooking);
    }
    public getLandDescription(localityPk:any){
      return this.http.get<any>(this.usersUrl + 'getLandDescriptionList/'+localityPk);
    }   
    public getPurpose(bookingAreaType:any){
      return this.http.get<BookingAreaTypeModel>(this.usersUrl + 'getBookingAreaType/'+bookingAreaType);
    }
    public getCategoryType(bookingAreaType:any){
      return this.http.get<BookingAreaTypeModel>(this.usersUrl + 'getBookingAreaType/'+bookingAreaType);
    }
    public getState(){
      return this.http.get<CountryModel>(this.usersUrl + 'getStateList/'+1);
    }
    public getDistict(stateId){
      return this.http.get<StateModel>(this.usersUrl + 'getDistrictList/'+stateId);
    }
    public getCity(distictId){
      return this.http.get<DistrictModel>(this.usersUrl + 'getCityList/'+distictId);
    }
    public getAreaDescription(ldId){
      return this.http.get<LandDescriptionModel>(this.usersUrl + 'getAreaDescriptionList/'+ldId);
    }
    public getFunType(categoryType){
      return this.http.get<CategoryTypeModel>(this.usersUrl + 'getFunctionTypeList/'+categoryType);
    }
    public getFunName(functionType){
      return this.http.get<FunctionTypeModel>(this.usersUrl + 'getFunctionType/'+functionType);
    }
    public getFile(){
      return this.http.get<FileNumberModel>(this.usersUrl + 'getFileNumberList/');
    }
    public getSocietyName(fileNoId){
      return this.http.get<FileNumberModel>(this.usersUrl + 'getFileNumber/'+fileNoId);
    }
    public submitBookingDetails(onlineBooking){
      return this.http.post<ResponseMessage>(this.communityHall + 'saveCommunityHallDetails/',onlineBooking);
    }
    public submitSocietyRegistration(societyReg){
      return this.http.post<ResponeBookingDetails>(this.communityHall + 'saveSocietyRegistation/',societyReg);
    }
    public checkAvailability(onlineBooking){
      return this.http.post<ResponseMessage>(this.communityHall + 'checkAvailability/',onlineBooking);
    }
    public checkAvailabilityList(availability){
      return this.http.post<ResponseMessage>(this.communityHall + 'checkAvailabilityList/',availability);
    }
    public getListCoomunityHallBookingForm(id,roleName){
      const params = new HttpParams()
        .set('id', id)
        .set('roleName', roleName);
      return this.http.get<any[]>(this.communityHall + 'getListCoomunityHallBookingForm',{params});
    }
    public communityHallProcess(data){
      return this.http.post<ResponseMessage>(this.workFlow +'communityHallProcess/',data);
    }
    public getWorkFlowStatusByAppNo(appId){
      return this.http.get<any>(this.workFlow + 'getWorkFlowStatusByAppNo/'+appId);
    }
    public getRwaRegistrationListByDate(appId){
      return this.http.post<any>(this.workFlow + 'numberOfApplication/',appId);
    }
    public returnCommunityHallSaveDetails(data){
      return this.http.post<ResponseMessage>(this.communityHall + 'returnCommunityHallSaveDetails/',data);
    }
    public getDetailsOfReturnRequestById(id,roleName){
      const params = new HttpParams()
      .set('id', id)
      .set('roleName', roleName);
      return this.http.get<any>(this.communityHall + 'getDetailsOfReturnRequestById/',{params});
    }
    public getDetailsOfHandOverById(id){
      return this.http.get<any>(this.communityHall + 'getDetailsOfHandOverById/'+id);
    }
    public getDetailsOfReturnRequestByuserId(id){
      return this.http.get<ResponseMessage>(this.communityHall + 'getDetailsOfReturnRequestByuserId/'+id);
    }
    public returnCommunityHallProcess(data){
      return this.http.post<any>(this.returnWorkFlow + 'returnCommunityHallProcess/',data);
    }
    public getWorkFlowStatusByAppNoReturnRequest(id){
      return this.http.get<any>(this.returnWorkFlow + 'getWorkFlowStatusByAppNo/'+id);
    }
    public recordDamageCommunityHallSaveDetails(data){
      return this.http.post<ResponseMessage>(this.communityHall + 'recordDamageCommunityHallSaveDetails/',data);
    }
    public getDetailsOfRecordDamageById(id){
      return this.http.get<any>(this.communityHall + 'getDetailsOfRecordDamageById/'+id);
    }
    public numberOfApplicationReturnRequest(data){
      return this.http.post<any>(this.returnWorkFlow + 'numberOfApplication/',data);
    }
    public searchBookedCommunityHall(data){
      return this.http.post<any>(this.communityHall + 'searchBookedCommunityHall/',data);
    }
    public moneyDeductionSave(data){
      return this.http.post<ResponseMessage>(this.communityHall + 'moneyDeductionSave/',data);
    }
    public getmoneyDeductionDetails(id){  
      return this.http.get<RecordDamageOnSiteCommunityHallModel>(this.communityHall + 'getmoneyDeductionDetails/'+id);
    }
    public getmoneyRefundListDetails(id,roleName){ 
      const params = new HttpParams()
      .set('id', id)
      .set('roleName', roleName);
      return this.http.get<any>(this.communityHall + 'getmoneyRefundListDetails/',{params});
    }
    public submitMoneyDeductionProcess(data){
      return this.http.post<any>(this.moneyDeductionWF + 'moneyDeductionProcess/',data);
    }
    public getWorkFlowStatusByAppNoMoneyDeduction(id){
      return this.http.get<any>(this.moneyDeductionWF + 'getWorkFlowStatusByAppNo/'+id);
    }
    public getMoneyDeductionCommunityHallListByDate(data){
      return this.http.post<any>(this.moneyDeductionWF + 'numberOfApplication/',data);
    }
    public getDetailsOfMoneyDeductionById(id){
      return this.http.get<any>(this.communityHall + 'getDetailsOfMoneyDeductionById/'+id);
    }
    public moneyRefundSave(data){
      return this.http.post<ResponseMessage>(this.communityHall + 'moneyRefundSave/',data);
    }
    public getCommunityHallDetailsbyApplicationid(data){
      return this.http.get<any>(this.communityHall + 'getCommunityHallDetailsbyApplicationid/'+data);
    }
    public getmoneyRefundDetails(data){
      return this.http.get<any>(this.communityHall + 'getmoneyRefundDetails/'+data);
    }
    public cancelCommunityHallSaveDetails(data){
      return this.http.post<ResponseMessage>(this.communityHall + 'cancelCommunityHallSaveDetails/',data);
    }
    public getDetailsOfCancelRequestById(id,roleName){
      const params = new HttpParams()
      .set('id', id)
      .set('roleName', roleName);
      return this.http.get<any>(this.communityHall + 'getDetailsOfCancelRequestById/',{params});
    }
    public communityHallCancelProcess(data){
      return this.http.post<any>(this.cancelCHWF + 'communityHallCancelProcess/',data);
    }
    public getCoomunityHallBookingForm(data){
      return this.http.get<any>(this.communityHall + 'getCoomunityHallBookingForm/'+data);
    }
    public getListAllCoomunityHallBookingForm(){
      return this.http.get<any>(this.communityHall + 'getListAllCoomunityHallBookingForm');
    }
    public disableLandDescription(data){
      return this.http.post<ResponseMessage>(this.usersUrl + 'disableLandDescription/',data);
    }
    public relaxationSaveDetails(data){
      return this.http.post<ResponseMessage>(this.communityHall + 'relaxationSaveDetails/',data);
    }
    public getListAllRelaxationForm(id,roleName){
      const params = new HttpParams()
      .set('id', id)
      .set('roleName', roleName);
      return this.http.get<any>(this.communityHall + 'getListAllRelaxationForm/',{params});
    }
    public communityHallRelaxationProcess(data){
      return this.http.post<any>(this.relaxationWF + 'communityHallRelaxationProcess/',data);
    }
    public getWorkFlowStatusByAppNoRelaxation(appId){
      return this.http.get<any>(this.relaxationWF + 'getWorkFlowStatusByAppNo/'+appId);
    }
    public getRelaxationListByDate(data){
      return this.http.post<any>(this.relaxationWF + 'numberOfApplication/',data);
    }
    public otpToJE(data){
      return this.http.post<ResponseMessage>(this.communityHall + 'otpToJE/',data);
    }
    public getFloorList(id){
      return this.http.get<any>(this.usersUrl + 'getFloorList/'+id);
    }
    public getContiguousIdList(ldId){
      return this.http.get<any>(this.communityHall + 'getContiguousIdList/'+ldId);
    }
    public sendMessageToApplicant(data){
      return this.http.post<ResponseMessage>(this.communityHall + 'sendMessageToApplicant/',data);
    }
    public getLandDescriptionAll(){
      return this.http.get<any>(this.usersUrl + 'getLandDescription');
    }
    public getListOfSayaDays(){
      return this.http.get<any>(this.communityHall + 'getListOfSayaDays');
    }
  }
 